export default __webpack_public_path__ + "static/media/net-white.a53a16e3.svg";